/**
 * Decode any encoded HTML entities in an input string.
 * @param input {string} A string to have encoded HTML entities decoded.
 * @returns {string|undefined} The input argument with encoded HTML entities decoded.
 * @link https://stackoverflow.com/a/34064434/19588
 */
export function htmlDecode(input) {
    const doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
}
